import useParties from '../useParties/useParties';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { spiceroad } from '..';

export interface SessionProps {
  isSessionLoading: boolean;
  sessionDetails: any;
  isSessionError: any;
  triggerSessionDetails: any;
  mutation: UseMutationResult<any, Error, void>;
}

export function postSession(): SessionProps {
  const { hasLOC, isErrorParties, isLoadingParties } = useParties();

  const mutation = useMutation({
    mutationFn: () => spiceroad.post(`/v1/locs/instantfunding/${hasLOC}`, {}).then((res) => res.data),
    mutationKey: ['postSession', hasLOC],
  });

  return {
    sessionDetails: mutation.data,
    isSessionLoading: mutation.isPending || isLoadingParties,
    isSessionError: mutation.error || isErrorParties,
    triggerSessionDetails: mutation.mutateAsync,
    mutation,
  };
}

export default postSession;
